import styled from 'styled-components';

export const Title = styled.h5`
  font-size: 18px;
  color: ${(props) => props.theme.$dark};
`;
